import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useNavigate } from "react-router-dom";
import { useCentralStore } from "stores";
import { useExpenseStore } from "../store";

export const paymentRequisition = ({
  churchId,
  requisitionData,
  requisitionId
}) => {
  return axios.patch(
    `/churches/${churchId}/requisitions/${requisitionId}/payment`,
    requisitionData
  );
};

export const usePaymentRequisition = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;
  const closeMakePaymentModal =
    useExpenseStore.getState().closeMakePaymentModal;

  const navigate = useNavigate();

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(["requisitions"]);
      queryClient.invalidateQueries(["requisitions-paginated"]);
      queryClient.invalidateQueries(["requisition"]);

      setNotification({
        type: "success",
        message: "Requisition paid successfully!"
      });

      closeMakePaymentModal();
      navigate(`/finances/temp/expense/requisition`);
    },
    ...config,
    mutationFn: paymentRequisition
  });
};
